var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, } from "react";
import cn from "classnames";
import uniqueId from "lodash.uniqueid";
import s from "./Input.module.css";
export function fixControlledValue(value) {
    if (typeof value === "undefined" || value === null) {
        return "";
    }
    return value;
}
var Input = function (props) {
    var className = props.className, _a = props.error, error = _a === void 0 ? "" : _a, success = props.success, icon = props.icon, label = props.label, _b = props.required, required = _b === void 0 ? false : _b, children = props.children, onChange = props.onChange, placeholder = props.placeholder, value = props.value, rest = __rest(props, ["className", "error", "success", "icon", "label", "required", "children", "onChange", "placeholder", "value"]);
    var id = useState(uniqueId("input-field-"))[0];
    var _c = useState(value), inputValue = _c[0], setValue = _c[1];
    var wrapperClassName = cn(s.wrapper, {}, className);
    var handleOnChange = function (e) {
        setValue(e.target.value);
        if (onChange) {
            onChange(e);
        }
        return null;
    };
    return (_jsxs("div", __assign({ className: wrapperClassName }, { children: [label && (_jsx("label", __assign({ htmlFor: id, className: s.label }, { children: label }), void 0)),
            _jsxs("div", __assign({ className: s.inputWrapper }, { children: [_jsx("input", __assign({ id: id, value: fixControlledValue(inputValue), required: required, className: s.root, onChange: handleOnChange, placeholder: placeholder, autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: "false" }, rest), void 0),
                    icon && _jsx("span", __assign({ className: s.icon }, { children: icon }), void 0)] }), void 0),
            success && _jsx("div", __assign({ className: s.success }, { children: success }), void 0),
            error && (_jsx("div", __assign({ role: "alert", className: s.error }, { children: error }), void 0))] }), void 0));
};
export default Input;
